export default "<span class=\"text-time-ago\">\r\n  {{ timeAgo }}\r\n</span>\r\n";